/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Dispatched_IntroInputs */

const en_chat_dispatched_intro = /** @type {(inputs: Chat_Dispatched_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispatched tasks:`)
};

const fr_chat_dispatched_intro = /** @type {(inputs: Chat_Dispatched_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tâches dispatchées :`)
};

const ms_sg2_chat_dispatched_intro = /** @type {(inputs: Chat_Dispatched_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugasan dilancarkan:`)
};

/**
* | output |
* | --- |
* | "Dispatched tasks:" |
*
* @param {Chat_Dispatched_IntroInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_dispatched_intro = /** @type {((inputs?: Chat_Dispatched_IntroInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dispatched_IntroInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_dispatched_intro(inputs)
	if (locale === "fr") return fr_chat_dispatched_intro(inputs)
	return ms_sg2_chat_dispatched_intro(inputs)
});